const UNCONFIGURED = 'unconfigured'
const CONFIGURED = 'configured'
const FAILED = 'failed'

const STATUS_BY_SEVERITY = {
  [UNCONFIGURED]: 'info',
  [CONFIGURED]: 'success',
  [FAILED]: 'error',
}

const ALERT_MESSAGE_BY_STATUS = {
  [UNCONFIGURED]:
    'Servidor SMTP não configurado. Configure para enviar e-mails. clique no botão "Testar conexão" para verificar a configuração.',
  [CONFIGURED]: 'Servidor SMTP configurado com sucesso. Última configuração em',
  [FAILED]:
    'Erro ao configurar o servidor SMTP. Não será possível utilizar essas credenciais para enviar e-mails.',
}

const AUTHENTICATION_TYPES = [
  { name: 'Login', id: 'login' },
  { name: 'Plain', id: 'plain' },
  { name: 'Cram-Md5', id: 'cram-md5' },
]

const INFO_MESSAGES_BY_FIELD = {
  fromEmail:
    'O e-mail de envio é utilizado como remetente das mensagens enviadas pelo sistema. geralmente é o mesmo do username.',
  domain:
    'O domínio no SMTP é utilizado para identificar quem está enviando o e-mail durante a comunicação com o servidor. Normalmente, configura-se o domínio da sua aplicação ou do servidor de e-mail utilizado, por exemplo: meusite.com ou mail.meusite.com. Em alguns casos, provedores também aceitam que seja informado o domínio do serviço de e-mail, como gmail.com ou outlook.com.',
  enableStarttlsAuto:
    'Quando ativado, tentamos estabelecer uma conexão criptografada (TLS) com seu servidor de e-mail automaticamente, caso ele suporte esse recurso. Recomendamos manter esta opção ativada, pois garante mais segurança no envio dos seus e-mails. Desative apenas se o seu servidor de e-mail não oferece suporte a STARTTLS ou se você está enfrentando erros de conexão relacionados a certificados SSL/TLS. Nesse caso, consulte o administrador do seu servidor de e-mail antes de desativar.',
  starttls:
    'Quando ativado, tentamos estabelecer uma conexão criptografada (TLS) com o servidor de e-mail automaticamente, caso ele suporte esse recurso. Recomendado para a maioria dos servidores SMTP, geralmente na porta 587.',
  ssl: 'Quando ativado, a conexão com o servidor de e-mail é estabelecida via SSL/TLS desde o início, geralmente na porta 465. Normalmente não é usado em conjunto com o STARTTLS — verifique qual opção seu servidor de e-mail exige.',
  pemFile:
    'Envie o certificado (CA) do seu servidor de e-mail quando ele usar um certificado próprio/autoassinado, não emitido por uma autoridade certificadora pública. Sem isso, servidores com certificado próprio podem falhar na verificação de segurança durante o envio. Formatos aceitos: .pem, .crt, .cer.',
}

const smtp = {
  UNCONFIGURED,
  CONFIGURED,
  FAILED,
  STATUS_BY_SEVERITY,
  ALERT_MESSAGE_BY_STATUS,
  AUTHENTICATION_TYPES,
  INFO_MESSAGES_BY_FIELD,
}

export default smtp
